import * as types from '../types/blogTypes';

const initialState = {
  posts: [],
  post: null,
  loading: false,
  error: null,
  pagination: { page: 1, limit: 20, total: 0 },
};

const blogReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_BLOG_LIST_REQUEST:
    case types.FETCH_BLOG_ITEM_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_BLOG_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        posts: action.payload.data || [],
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };

    case types.FETCH_BLOG_ITEM_SUCCESS:
      return { ...state, loading: false, post: action.payload || null, error: null };

    case types.FETCH_BLOG_LIST_FAILURE:
    case types.FETCH_BLOG_ITEM_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.CLEAR_BLOG_ITEM:
      return { ...state, post: null, error: null };

    default:
      return state;
  }
};

export default blogReducer;

